import React from 'react';

const X_AXIS_MAX = 100;

function WinRateTrendChart({ points, emptyLabel, hiddenLabel, visible = true }) {
    const height = 140;
    const padding = { top: 14, right: 16, bottom: 36, left: 44 };
    const plotWidth = 900;
    const width = plotWidth + padding.left + padding.right;
    const plotHeight = height - padding.top - padding.bottom;
    const yMin = 0;
    const yMax = 1;
    const yRange = yMax - yMin;

    const toX = (turn) => padding.left + (Math.max(0, Math.min(turn, X_AXIS_MAX)) / X_AXIS_MAX) * plotWidth;
    const toY = (rate) => {
        if (rate === null || Number.isNaN(rate)) {
            return null;
        }
        return padding.top + plotHeight - ((rate - yMin) / yRange) * plotHeight;
    };

    if (!visible) {
        return (
            <div className="win-rate-trend-chart win-rate-trend-chart--hidden">
                <span>{hiddenLabel}</span>
            </div>
        );
    }

    if (!points || points.length === 0) {
        return (
            <div className="win-rate-trend-chart win-rate-trend-chart--empty">
                <span>{emptyLabel}</span>
            </div>
        );
    }

    const sortedPoints = points.slice().sort((a, b) => a.turn - b.turn);
    const yTicks = [0, 0.25, 0.5, 0.75, 1];
    const xTicks = [0, 25, 50, 75, 100];

    const linePoints = sortedPoints
        .map((p) => {
            const y = toY(p.winRate === null || p.winRate === undefined ? null : Number(p.winRate));
            if (y === null) {
                return null;
            }
            return `${toX(p.turn)},${y}`;
        })
        .filter(Boolean)
        .join(' ');

    return (
        <div className="win-rate-trend-chart">
            <svg viewBox={`0 0 ${width} ${height}`} className="win-rate-trend-chart__svg" width="100%" height={height}>
                {yTicks.map((tick) => {
                    const y = toY(tick);
                    return (
                        <g key={`y-tick-${tick}`}>
                            <line
                                x1={padding.left}
                                y1={y}
                                x2={width - padding.right}
                                y2={y}
                                className="win-rate-trend-chart__grid"
                            />
                            <text
                                x={padding.left - 6}
                                y={y + 4}
                                textAnchor="end"
                                className="win-rate-trend-chart__axis-label"
                            >
                                {(tick * 100).toFixed(0)}%
                            </text>
                        </g>
                    );
                })}
                {xTicks.map((tick) => (
                    <text
                        key={`x-tick-${tick}`}
                        x={toX(tick)}
                        y={height - 8}
                        textAnchor="middle"
                        className="win-rate-trend-chart__turn-label"
                    >
                        {tick}
                    </text>
                ))}
                {linePoints && <polyline points={linePoints} className="win-rate-trend-chart__line" />}
                {sortedPoints.map((p, index) => {
                    const rate = p.winRate === null || p.winRate === undefined ? null : Number(p.winRate);
                    const y = toY(rate);
                    if (y === null) {
                        return null;
                    }
                    return (
                        <circle
                            key={`point-${p.turn}-${index}`}
                            cx={toX(p.turn)}
                            cy={y}
                            r="3.5"
                            className="win-rate-trend-chart__dot"
                        />
                    );
                })}
            </svg>
        </div>
    );
}

export default WinRateTrendChart;
